module.exports = __webpack_public_path__ + "static/media/logo_white.721e0189.png";